<template>
    <div>
        <el-dialog :title="titleName"
                   :visible.sync="dialogFormVisible"
                   width="55%"
                   class="diccss"
        >
            <el-form :model="form" style="text-align: center" :rules="rules" ref="ruleForm">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="字典类型" :label-width="formLabelWidth" :required="true" prop="type">
                            <el-input v-model="form.type" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="类型名称" :label-width="formLabelWidth" :required="true" prop="description">
                            <el-input v-model="form.description" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="字典值" :label-width="formLabelWidth" :required="true" prop="value">
                            <el-input v-model="form.value" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="排列序号" :label-width="formLabelWidth" :required="true" prop="sort">
                            <el-input-number v-model="form.sort" :min="1" :max="100" label="输入数字"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!--<el-row>
                    <el-col :span="12">
                        <el-form-item label="父级字典" :label-width="formLabelWidth">
                            <el-select v-model="form.parentId" @change="selectFun" filterable placeholder="请选择父级字典">
                                <el-option
                                        v-for="item in selectParents"
                                        :key="item.id"
                                        :label="item.name+'('+item.value+')'"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="字典名称" :label-width="formLabelWidth" :required="true" prop="name">
                            <el-input v-model="form.name" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>-->

                <!--<el-row>
                    <el-col :span="24">
                        <el-form-item label="备注信息" :label-width="formLabelWidth">
                            <el-input v-model="form.remarks" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>-->

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="addAndUpdate('ruleForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'DicEdit',
        data() {
            return {
                dialogFormVisible: true,
                url: '',
                titleName: '',
                selectParents: [],
                form: {
                    id: '',
                    parentId: '',
                    name: '',
                    value: '',
                    type: '',
                    description: '',
                    sort: '',
                    remarks: ''
                },
                rules: {
                    /*name: [{required: true, message: '请输入标签名称', trigger: 'blur'}],*/
                    value: [{required: true, message: '请输入标签代码', trigger: 'blur'}],
                    type: [{required: true, message: '请输入类型代码', trigger: 'blur'}],
                    description: [{required: true, message: '请输入类型描述', trigger: 'blur'}],
                    sort: [{required: true, message: '请输入排列序号', trigger: 'blur'}]
                },
                formLabelWidth: '120px'
            };
        },
        methods: {
            int(id, type, typeName) {

                this.$refs['ruleForm'].resetFields();
                this.form.id = '';
                this.form.parentId = '';
                this.form.name = '';
                this.form.value = '';
                this.form.type = '';
                this.form.sort = '';
                this.form.description = '';
                this.form.remarks = '';
                this.dialogFormVisible = true;

                if (id == 'add') {
                    this.form.type = type;
                    this.form.description = typeName;
                    this.titleName = "数据字典-新增";
                    this.url = "/common/dict/save";
                    this.inItSelectParents();
                } else {
                    this.url = "/common/dict/update";
                    this.titleName = "数据字典-修改";
                    this.$httpTAG({
                        url: this.$httpTAG.adornUrl('/common/dict/view'),
                        method: 'post',
                        data: this.$httpTAG.adornData({
                            'id': id
                        })
                    }).then(r => {
                        this.form = r.data.data;
                        this.inItSelectParents();
                    }).finally(r => {
                    })
                }
            },
            inItSelectParents() {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/common/dict/listByType'),
                    method: 'post',
                    data: this.$httpTAG.adornData({
                        'type': this.form.type
                    })
                }).then(r => {
                    this.selectParents = r.data.data;
                }).finally(r => {
                })
            },
            addAndUpdate(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {

                        this.$httpTAG({
                            url: this.$httpTAG.adornUrl(this.url),
                            method: 'post',
                            data: this.$httpTAG.adornData({
                                'id': this.form.id,
                                'parentId': this.form.parentId,
                                'name': this.form.name,
                                'value': this.form.value,
                                'type': this.form.type,
                                'description': this.form.description,
                                'sort': this.form.sort,
                                'remarks': this.form.remarks
                            })
                        }).then(res => {
                            if (res.data.code == 0) {
                                this.$notify({
                                    title: '操作成功！',
                                    type: 'success',
                                    offset: 600
                                });
                                this.dialogFormVisible = false
                                this.$emit("handleRefresh", 1);
                            } else {
                                this.$message({ // 失败
                                    type: 'fail',
                                    message: res.data.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                }).finally(r => {
                })

            }
        }
    };
</script>
<style scoped>
    .diccss >>> .el-dialog__body {
        padding: 25px 85px 30px 20px;
    }
</style>
